<template>
  <div class="relative flex flex-col lg:flex-row">
    <div class="lg:h-screen flex flex-col  lg:max-w-sm w-full flex-shrink-0 border-r">
      <div class="w-full px-6 h-20 border-b">
        <div class="max-w-7xl h-full w-full flex justify-center items-center mx-auto">
          <h4 class="text-yank">Settings</h4>
        </div>
      </div>
        <div class="flex flex-row sm:flex-col border-b lg:border-none">
          <div class="flex-1 md:pl-6 hover:bg-platinumMild sm:hover:bg-platinumHot" :class="{'sm:bg-platinumHot sm:hover:bg-platinumHot': this.page == 'location'}">
            <inertia-link class="flex lg:ml-none items-center justify-center md:justify-between pr-5 text-sm font-medium text-yank relative py-4 leading-1 md:border-b border-r lg:border-r-none border-platinumFire" :href="$route('social-settings.show', 'location')">
              Location Settings
              <ChevronRight class="h-5 w-5 text-payneFire hidden sm:block" />
            </inertia-link>
          </div>
          <div class="flex-1 md:pl-6 lg:ml-none hover:bg-platinumMild sm:hover:bg-platinumHot" :class="{'sm:bg-platinumHot sm:hover:bg-platinumHot': (this.page == 'settings')}">
            <inertia-link class="flex items-center justify-center md:justify-between pr-5 text-sm font-medium text-yank relative py-4 leading-1" :href="$route('social-settings.show', 'settings')">
              Social Media Channels
              <ChevronRight class="h-5 w-5 text-payneFire hidden sm:block" />
            </inertia-link>
          </div>
        </div>
      </div>
    <template>
        <MediaEmptySetting v-if="page == 'settings' && accounts.length === 0 && openSettings === false" @goToChannelSetting="openChannelSetting" />
        <LocationSetting v-if="page == 'location'"/>
        <MediaSetting 
          v-if="page == 'settings' && (accounts.length > 0 || openSettings === true) "
          @updateConnection="connectToFacebook"
          @removeConnection="removeConnectionModal = true;"
          @updateGroupsConnection="connectGroups"
          :accounts="accounts"
          :invalidAccounts="invalidAccounts"
          :userPages="userPages"
          :userGroups="userGroups"
          :userAccounts="userAccounts"
        />    
    </template>
    <portal to="facebookModal"> 
      <div v-show="removeConnectionModal" class="flex justify-center items-center absolute z-20 bg-gray-500 bg-opacity-30 h-screen w-full">
        <ConfirmRemovalModal v-if="removeConnectionModal" :account="accounts[0]" @closeModal="removeConnectionModal = false"/>
      </div>
    </portal> 
  </div>
</template>

<script>
  import { VueLoading } from 'vue-loading-template';

  import AppLayout from '@/layout/app-layout';
  import ChevronRight from '@/components/svg/ChevronRight';
  import MediaEmptySetting from '@/components/settings/social/MediaEmptySetting';
  import LocationSetting from '@/components/settings/social/LocationSetting';
  import MediaSetting from '@/components/settings/social/MediaSetting';
  import FacebookLogin from '@/components/settings/partials/FacebookLogin';
  import ConfirmRemovalModal from '@/components/scheduler/Common/ConfirmRemovalModal';
  import ConfirmGroupModal from '@/components/settings/partials/ConfirmGroupModal';

  export default {
    name: 'SocialSettings',

    layout: AppLayout,
    
    components: {
      ChevronRight,
      MediaEmptySetting,
      LocationSetting,
      MediaSetting,
      FacebookLogin,
      ConfirmGroupModal,
      ConfirmRemovalModal,
      VueLoading
    },

    props: {
      page:{
        type:String,
        required:true
      } ,
      flash:{
       type:Object,
       required:true
      } ,
      accounts: {
        type:Array,
        required:true
      } ,
      invalidAccounts: {
        type:Array,
        required:true
      },
      userPages:{
        type:Array,
        require:true
      },
      userGroups:{
        type:Array,
        require:true
      },
      userAccounts:{
        type:Array,
        require:true
      }
    },

    data() {
      return {
        connectionsModal: false,
        removeConnectionModal: false,
        provider: '',
        openSettings:false,
        loading: false,
      }
    },

    methods: {
      openChannelSetting(){
        this.openSettings = true;
      },

      connectGroups() {
        console.log("HERE");
        FB.login((response) => {
          if (response.status === 'connected') {
            this.getFacebookProfile(response.authResponse.accessToken, 'group');
          } else {
            console.log('You are not logged in'); 
          }
        }, 
        {
            scope: 'publish_to_groups,groups_access_member_info', 
            return_scopes: true,
            auth_type: 'rerequest,reauthenticate,reauthorize',
            enable_profile_selector: true
        });
      },

      connectToFacebook() {
        console.log("Connect to facebook account")
        FB.login((response) => {
          if (response.status === 'connected') {
            this.getFacebookProfile(response.authResponse.accessToken, 'account');
          } else {
            console.log('You are not logged in'); 
          }
        }, 
        {
            scope: 'email,public_profile,pages_show_list,pages_read_engagement,pages_manage_posts,instagram_content_publish,instagram_basic', 
            return_scopes: true,
            auth_type: 'rerequest,reauthenticate,reauthorize',
            enable_profile_selector: true
        });
      },
      
      getFacebookProfile(accessToken, connectionType) {
        FB.api('/me', 'GET', {"fields":"id,name,email, picture"}, (response) => 
        {
          const payload = {
            user_data: {'id': response.id,
            'email': response.email,
            'name': response.name,
            'picture': response.picture},
            id_token: accessToken,
          }
          this.processFacebookProfile(payload, connectionType);
        });
      },

      processFacebookProfile: async function (payload, connectionType) {
        await this.checkLogin(payload, connectionType);
      },

      checkLogin: async function (payload, connectionType) {
        this.$inertia.post(this.$route('social-accounts.store', connectionType), payload);
        this.$emit('closeModal');
      },
    },


    watch: {
      flash: {
        handler(flash) {
          if (flash.success && flash.success !== '') {
            this.$toast.success(flash.success);
          }
          if (flash.error && flash.error !== '') {
           this.$toast.error(flash.error);
          }
        },
        deep: true,
      }
    },
  }
</script>